import React from 'react';
import myPicture from '../../assets/myPicture.png';
import skills from '../../info/skills.js';
import technology from '../../info/technology.js';
import styles from './About.module.css';

const About = () => {
     return (
          <div id="about" className={styles.container}>
               <div className={styles.title_container}>
                    <p data-aos="fade-right" className={styles.title}>
                         ABOUT
                    </p>
                    <div data-aos="fade-right" data-aos-delay="50" className={styles.line}></div>
               </div>
               <div className={styles.skills_container}>
                    {skills.map((skill) => {
                         return (
                              <div
                                   data-aos="flip-left"
                                   data-aos-duration="600"
                                   data-aos-delay={skill.delay}
                                   key={skill.skill}
                                   className={styles.skill}
                              >
                                   <div className={styles.triangulo_a}></div>
                                   <div className={styles.rectangulo}>
                                        <img
                                             className={styles.skill_ico}
                                             src={skill.ico}
                                             alt={skill.title}
                                        />
                                   </div>
                                   <div className={styles.triangulo_b}></div>
                                   <p className={styles.title_skill}>{skill.title}</p>
                                   <p className={styles.data_skill}>{skill.description}</p>
                              </div>
                         );
                    })}
               </div>
               <div className={styles.aboutMe_container}>
                    <div className={`${styles.me_pc} ${styles.myInfo_container}`}>
                         <div data-aos="fade-right" data-aos-duration="1500">
                              <div className={styles.myInfo}>
                                   <img
                                        className={styles.myPicture}
                                        src={myPicture}
                                        alt="Agustin Ojeda Developer"
                                   ></img>
                                   <p className={styles.title_skill}>Who am I?</p>
                                   <p className={styles.data_skill}>
                                        {' '}
                                        I am a responsible and applied person. My objective is to
                                        always look for the best result and overcome any challenge.
                                        I enjoy being in a team so I adapt easily. I am always
                                        willing to collaborate and learn from others to improve my
                                        skills.
                                   </p>
                                   <a className={styles.contactMe} href="#contact">
                                        Let's make something special.
                                   </a>
                              </div>
                         </div>
                    </div>
                    <div className={styles.me_mobile}>
                         <div
                              data-aos="fade-zoom-in"
                              data-aos-easing="ease-in-back"
                              data-aos-duration="1000"
                              data-aos-anchor-placement="bottom-bottom"
                              className={styles.myInfo_container}
                         >
                              <div className={styles.myInfo}>
                                   <img
                                        className={styles.myPicture}
                                        src={myPicture}
                                        alt="Agustin Ojeda Developer"
                                   ></img>
                                   <p className={styles.title_skill}>Who am I?</p>
                                   <p className={styles.data_skill}>
                                        {' '}
                                        I am a responsible and applied person. My objective is to
                                        always look for the best result and overcome any challenge.
                                        I enjoy being in a team so I adapt easily. I am always
                                        willing to collaborate and learn from others to improve my
                                        skills.
                                   </p>
                                   <a className={styles.contactMe} href="#contact">
                                        Let's make something special.
                                   </a>
                              </div>
                         </div>
                    </div>
                    <div className={styles.technology_container}>
                         <div
                              className={styles.technology_container_animation}
                              data-aos="fade-left"
                              data-aos-duration="1500"
                         >
                              {technology.map((data) => {
                                   return (
                                        <div key={data.name} className={styles.technology}>
                                             <div className={styles.barName_container}>
                                                  <p className={styles.barName}>{data.name}</p>
                                             </div>
                                             <div className={styles.barLine_container}>
                                                  <div
                                                       style={{
                                                            width: data.porcentage,
                                                            height: '100%',
                                                            background: '#3888ff',
                                                       }}
                                                  ></div>
                                             </div>
                                             <div className={styles.barPorcentage}>
                                                  <p>{data.porcentage}</p>
                                             </div>
                                        </div>
                                   );
                              })}
                         </div>
                         <div className={styles.technology_container_animation_mobile}>
                              {technology.map((data) => {
                                   return (
                                        <div
                                             data-aos="fade-up"
                                             data-aos-duration="1500"
                                             key={data.name}
                                             className={styles.technology}
                                        >
                                             <div className={styles.barName_container}>
                                                  <p className={styles.barName}>{data.name}</p>
                                             </div>
                                             <div className={styles.barLine_container}>
                                                  <div
                                                       style={{
                                                            width: data.porcentage,
                                                            height: '100%',
                                                            background: '#3888ff',
                                                       }}
                                                  ></div>
                                             </div>
                                             <div className={styles.barPorcentage}>
                                                  <p>{data.porcentage}</p>
                                             </div>
                                        </div>
                                   );
                              })}
                         </div>
                    </div>
               </div>
               <div className={styles.border_bottom}></div>
          </div>
     );
};

export default About;
